import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/Button';
import { MapPin, CheckCircle2, Users, Target, Award } from 'lucide-react';
export function CityPage() {
  const programs = ['Kids Taekwondo', 'Teen Taekwondo', 'Adult Taekwondo', 'Competition / Team Training'];
  return <div className="min-h-screen bg-white" data-id="element-183">
      {/* Hero Section */}
      <section className="bg-neutral-900 text-white py-16 md:py-24" data-id="element-184">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-185">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center" data-id="element-186">
            <h1 className="text-4xl md:text-6xl font-black mb-6 tracking-tight" data-id="element-187">
              Taekwondo Classes Near{' '}
              <span className="text-red-600" data-id="element-188">Grapevine, Texas</span>
            </h1>

            <p className="text-lg md:text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto mb-10" data-id="element-189">
              If you are looking for Taekwondo classes near Grapevine, Texas,
              our school offers programs for kids, teens, and adults focused on
              confidence, discipline, fitness, and real-world self-defense.
              Families choose our Taekwondo school for structured instruction,
              positive coaching, and a welcoming environment.
            </p>

            <Button className="text-xl px-10 py-5" href="/signup" data-id="element-190" />
          </motion.div>
        </div>
      </section>

      {/* Why Taekwondo Section */}
      <section className="py-20 bg-white" data-id="element-191">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-192">
          <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-193">
            <motion.div className="lg:w-1/2" initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-194">
              <img src="https://images.unsplash.com/photo-1555597408-26bc8e548a46?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Taekwondo training near Grapevine" className="rounded-lg shadow-2xl" data-id="element-195" />
            </motion.div>

            <motion.div className="lg:w-1/2" initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-196">
              <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-6" data-id="element-197">
                Why Families Near Grapevine Choose Taekwondo
              </h2>

              <p className="text-lg text-neutral-600 mb-8 leading-relaxed" data-id="element-198">
                Taekwondo provides physical fitness, mental focus, and personal
                discipline for students of all ages. For families in and around
                Grapevine, Taekwondo is a powerful way to build confidence,
                improve coordination, and develop respect in a structured and
                supportive setting.
              </p>

              <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-199">
                <div className="flex items-center gap-2" data-id="element-200">
                  <Target className="w-5 h-5 text-red-700" data-id="element-201" />
                  <span className="font-semibold text-neutral-900" data-id="element-202">Focus</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-203">
                  <Users className="w-5 h-5 text-red-700" data-id="element-204" />
                  <span className="font-semibold text-neutral-900" data-id="element-205">
                    Community
                  </span>
                </div>
                <div className="flex items-center gap-2" data-id="element-206">
                  <Award className="w-5 h-5 text-red-700" data-id="element-207" />
                  <span className="font-semibold text-neutral-900" data-id="element-208">
                    Discipline
                  </span>
                </div>
                <div className="flex items-center gap-2" data-id="element-209">
                  <CheckCircle2 className="w-5 h-5 text-red-700" data-id="element-210" />
                  <span className="font-semibold text-neutral-900" data-id="element-211">
                    Confidence
                  </span>
                </div>
              </div>

              <Button href="/signup" data-id="element-212" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Programs Section */}
      <section className="py-20 bg-neutral-50" data-id="element-213">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-214">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center" data-id="element-215">
            <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-6" data-id="element-216">
              Taekwondo Programs for Kids, Teens, and Adults
            </h2>

            <p className="text-lg text-neutral-600 mb-10 leading-relaxed max-w-3xl mx-auto" data-id="element-217">
              Our Taekwondo programs are designed to support beginners and
              experienced students alike. Classes focus on age-appropriate
              instruction, goal-setting, and steady progress while maintaining a
              positive and motivating atmosphere.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10 max-w-2xl mx-auto" data-id="element-218">
              {programs.map((program, index) => <motion.div key={program} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="bg-white border-2 border-neutral-200 rounded-lg p-6 text-left" data-id="element-219">
                  <CheckCircle2 className="w-6 h-6 text-red-700 mb-3" data-id="element-220" />
                  <h3 className="font-bold text-lg text-neutral-900" data-id="element-221">
                    {program}
                  </h3>
                </motion.div>)}
            </div>

            <Button href="/signup" data-id="element-222" />
          </motion.div>
        </div>
      </section>

      {/* Location Section */}
      <section className="py-20 bg-white" data-id="element-223">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-224">
          <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-225">
            <motion.div className="lg:w-1/2" initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-226">
              <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-6" data-id="element-227">
                Conveniently Located Near Grapevine
              </h2>

              <p className="text-lg text-neutral-600 mb-8 leading-relaxed" data-id="element-228">
                Our Taekwondo school is located at Grapevine Mills, making it
                easy for families in the Grapevine area to attend classes
                consistently without long commutes. A convenient location helps
                students train regularly and see real progress over time.
              </p>

              <div className="bg-neutral-50 border-2 border-neutral-200 rounded-lg p-6 mb-8" data-id="element-229">
                <div className="flex items-start gap-3" data-id="element-230">
                  <MapPin className="w-6 h-6 text-red-700 flex-shrink-0 mt-1" data-id="element-231" />
                  <div data-id="element-232">
                    <p className="font-bold text-neutral-900 mb-1" data-id="element-233">
                      NTA Taekwondo
                    </p>
                    <p className="text-neutral-700" data-id="element-234">
                      3000 Grapevine Mills Pkwy
                      <br data-id="element-235" />
                      Grapevine, Texas 76051
                    </p>
                  </div>
                </div>
              </div>

              <Button href="/signup" data-id="element-236" />
            </motion.div>

            <motion.div className="lg:w-1/2" initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-237">
              <div className="rounded-lg overflow-hidden shadow-2xl" data-id="element-238">
                <img src="https://images.unsplash.com/photo-1599058945522-28d584b6f0ff?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Taekwondo school location" className="w-full h-full object-cover" data-id="element-239" />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Who This Is For Section */}
      <section className="py-20 bg-neutral-900 text-white" data-id="element-240">
        <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-241">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-242">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-243">
              Who Our Taekwondo Classes Are For
            </h2>

            <p className="text-lg text-gray-300 mb-10 leading-relaxed max-w-3xl mx-auto" data-id="element-244">
              Our classes are ideal for children who need structure and
              confidence, teens who want to build discipline and fitness, and
              adults looking for an effective and rewarding martial arts
              experience. No prior experience is required.
            </p>

            <Button href="/signup" data-id="element-245" />
          </motion.div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-24 bg-red-700 text-white" data-id="element-246">
        <div className="container mx-auto px-4 text-center max-w-3xl" data-id="element-247">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-248">
            <h2 className="text-4xl md:text-5xl font-black mb-6 tracking-tight" data-id="element-249">
              Start Taekwondo Near Grapevine Today
            </h2>

            <p className="text-xl text-red-100 mb-10 leading-relaxed" data-id="element-250">
              Getting started is simple. Sign up today and take the first step
              toward confidence, discipline, and improved fitness.
            </p>

            <Button variant="secondary" className="bg-white text-red-700 hover:bg-gray-100 focus:ring-white text-xl px-12 py-6" href="/signup" data-id="element-251" />
          </motion.div>
        </div>
      </section>
    </div>;
}